import { render, staticRenderFns } from "./CoozzyBarsIcon.vue?vue&type=template&id=4ca8c1c6&scoped=true"
import script from "./CoozzyBarsIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyBarsIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyBarsIcon.vue?vue&type=style&index=0&id=4ca8c1c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca8c1c6",
  null
  
)

export default component.exports